module.exports = __webpack_public_path__ + "img/ex06.636ae4a7.png";